// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.container-cards-historico {
    display: flex;
    flex-direction: column;
    min-width: 1254px;
    transition: 0.3s;
    border: 1px solid #ccc;
    border-radius: 12px;
    padding: 5px 10px;
    margin: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    color: var(--cDark);
    position: relative;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.item-historico {
    display: flex;
    width: 100%;
}

.titulo {
    color: var(--aiAzul);
    margin-left: 12px;
}

.tabela-card {
    display: grid;
    padding: 10px;
}

.container-cards-historico h2 {
    color: var(--aiAzul);
    font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/card-historico/card-style.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAIlB,2CAA2C;AAH/C;;AAMA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB","sourcesContent":["\n\n.container-cards-historico {\n    display: flex;\n    flex-direction: column;\n    min-width: 1254px;\n    transition: 0.3s;\n    border: 1px solid #ccc;\n    border-radius: 12px;\n    padding: 5px 10px;\n    margin: 10px;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    color: var(--cDark);\n    position: relative;\n}\n\n.container-cards-historico {\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\n.item-historico {\n    display: flex;\n    width: 100%;\n}\n\n.titulo {\n    color: var(--aiAzul);\n    margin-left: 12px;\n}\n\n.tabela-card {\n    display: grid;\n    padding: 10px;\n}\n\n.container-cards-historico h2 {\n    color: var(--aiAzul);\n    font-size: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
